import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IUserInfo } from '../admin/models/user.interface';

interface IExternalTokenUser {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  is_external: boolean;
}

interface IExternalTokenExecutor {
  id: number;
  email: string;
}

export interface IExternalTokenResponse {
  token: string;
  expires_at: string;
  user: IExternalTokenUser;
  executor: IExternalTokenExecutor;
  advisory: any;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public loginMethod: any;

  public token: any;
  public user: any;
  public customers: any;
  public company: any;
  params: any = {};
  onLogout: Subject<any> = new Subject<any>();

  onCheckAuth: Subject<any> = new Subject<any>();
  public externalTokenInfo: IExternalTokenResponse | null = null;
  public externalToken: string | null = null;

  constructor(public http: HttpClient) { }

  async getLoginMethod() {
    // Get current domain
    let domain = window.location.hostname;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json; version=ClientesV1',
      }),
    };
    let url = environment.url + '/crm/auth/';
    try {
      this.loginMethod = await this.http
        .post(url, { domain: domain }, httpOptions)
        .toPromise();
      return this.loginMethod;
    } catch (error) {
      console.log(error);
    }
  }

  setParams(params) {
    this.params = params;
  }

  isEmptyObject(object) {
    return Object.keys(object).length == 0;
  }

  getAuthHeaders(contentType = 'application/json') {
    let headers = {
      Accept: 'application/json; version=ClientesV1',
      Authorization: this.token,
    };
    if (contentType) headers['Content-Type'] = contentType;
    const httpOptions = {
      headers: new HttpHeaders(headers),
    };
    return httpOptions;
  }

  async getUserInfo() {
    let url = environment.url + '/rest-auth/user/';
    const headers = this.getAuthHeaders();
    console.debug('getUserInfo', url, headers);
    return this.http.get(url, headers).toPromise();
  }

  async checkAuthentication() {
    console.debug("Check auth");
    // TODO Not store token
    let value = await localStorage.getItem('token');

    console.debug('Stored token', value);
    // Validate if is stored token or token is in query params
    if (!value && !this.params.qs) return false;
    // If token is in query params take that
    if (!value) {
      let token = await this.getTokenFromQueryParams();
      if (!token) return false;
      value = 'token ' + token;
      // TODO Not store anything
      await localStorage.setItem('token', value);
    }
    this.token = value;
    this.user = await this.getUserInfo();
    await localStorage.setItem('appuser', JSON.stringify(this.user));
    this.onCheckAuth.next(this.user);
    return this.user;
  }

  async getTokenFromQueryParams() {
    console.debug('getTokenFromQueryParams', this.params.qs);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json; version=ClientesV1',
      }),
    };
    let url = environment.url + '/crm/auth/validate/';
    try {
      let value: any = await this.http
        .post(url, { qs: this.params.qs }, httpOptions)
        .toPromise();
      console.debug('getTokenFromQueryParams', value);

      return value.token;
    } catch (error) {
      return null;
    }
  }

  async validateExternalToken(tk: string): Promise<boolean> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json; version=ClientesV1',
      }),
    };
    const url = environment.url + '/crm/external/';
    try {
      const response = (await this.http.post(url, { qs: tk }, httpOptions).toPromise()) as IExternalTokenResponse;
      this.externalTokenInfo = response;
      this.externalToken = response.token;
      this.onCheckAuth.next(null);
      return true;
    } catch (error) {
      this.clearExternalSession();
      console.warn('validateExternalToken failed', error);
      return false;
    }
  }

  async logout() {
    console.debug('Log Out...');
    const headers = this.getAuthHeaders();
    let url = environment.url + 'crm/logout/';
    //let data = await this.http.get(url, headers).toPromise();
    // TODO Remove one signal token
    await this.clearStorage();
    location.reload();
  }

  async clearStorage() {
    await localStorage.setItem('token', '');
    await localStorage.setItem('appuser', '');
    this.clearExternalSession();
  }

  getAppUser(): IUserInfo {
    return (
      localStorage.getItem('appuser') &&
      JSON.parse(localStorage.getItem('appuser') as any)
    );
  }

  clearExternalSession() {
    this.externalToken = null;
    this.externalTokenInfo = null;
  }
}
